import type { Observable } from "rxjs";
import { map } from "rxjs/operators";
import xss from "xss";

import type { LoggerInterface } from "@interfaces/LoggerInterface";

import type HTMLSanitizerInterface from "./HTMLSanitizerInterface";
import type {
    HTMLSanitizeCssWhitelist,
    HTMLSanitizeTagsWhitelist,
} from "./HTMLSanitizerInterface";

class XSSHTMLSanitizer implements HTMLSanitizerInterface {
    constructor(
        private readonly logger: LoggerInterface,
        private readonly tagsWhiteList?: HTMLSanitizeTagsWhitelist,
        private readonly cssWhiteList?: HTMLSanitizeCssWhitelist
    ) {}
    handleIgnoreAttribute(
        tag: string,
        name: string,
        value: string,
        isWhiteAttr: boolean
    ) {
        this.logger.warn("ignored attribute", {
            tag,
            name,
            value,
            isWhiteAttr,
        });
    }
    handleIgnoreTag(tag: string, html: string, options: unknown) {
        this.logger.warn("ignored tag", {
            tag,
            html,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            options,
        });
    }

    sanitize(
        html: string,
        tagsWhiteList?: HTMLSanitizeTagsWhitelist,
        cssWhiteList?: HTMLSanitizeCssWhitelist
    ) {
        return xss(html, {
            whiteList: tagsWhiteList || this.tagsWhiteList,
            css: {
                whiteList: cssWhiteList || this.cssWhiteList,
            },
            onIgnoreTag: this.handleIgnoreTag.bind(this),
            onIgnoreTagAttr: this.handleIgnoreAttribute.bind(this),
        });
    }
    sanitize$(
        html: Observable<string>,
        tagsWhiteList?: HTMLSanitizeTagsWhitelist,
        cssWhiteList?: HTMLSanitizeCssWhitelist
    ) {
        return html.pipe(
            map((html) => {
                const result = xss(html, {
                    whiteList: tagsWhiteList || this.tagsWhiteList,
                    css: {
                        whiteList: cssWhiteList || this.cssWhiteList,
                    },
                    onIgnoreTag: this.handleIgnoreTag.bind(this),
                    onIgnoreTagAttr: this.handleIgnoreAttribute.bind(this),
                });
                return result;
            })
        );
    }
}

export default XSSHTMLSanitizer;
